
import Vue, { PropOptions } from 'vue'
import { mdiChevronDown } from '@mdi/js'
export default Vue.extend({
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    } as PropOptions<
      {
        icon: string
        title: string
        subTitle: string
        anchor: string
      }[]
    >,
  },
  data() {
    return {
      mdiChevronDown,
    }
  },
})
